module.exports = __webpack_public_path__ + "img/main_door_on.21939a5e.png";